<template>
  <footer class="footer-wrap">
    <div class="safe-wrapper footer-wrap-layer">
      <div class="footer-mesLeft">
        <span>主办单位：中国企业评价协会&nbsp;&nbsp;&nbsp;康养合规专业委员会&nbsp;&nbsp;&nbsp;电话：010-53670365&nbsp;&nbsp;&nbsp;（工作日 9:30—17:00）&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <span>
          版权所有：养老合规师考试网
          <a href="https://beian.miit.gov.cn/" target="_blank" style="text-decoration: none;color: #ffffff;" rel="nofollow">京ICP备2024047921号-2</a>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <img src="../assets/image/gaico.png" border="0">
          <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502055751" target="_blank" style="text-decoration: none;color: #ffffff;" rel="nofollow">京公网安备 11010502055751号</a>
        </span>
        <span></span>
      </div>
      <div class="footer-mesRight">
        <!-- <div class="footer-mesRight-code footer-mesRight-code-01">
          <span></span>
          <span>委员会官方公众号<br>关注看考试公开课</span>
        </div> -->
        <div class="footer-mesRight-code footer-mesRight-code-02">
          <span></span>
          <span>养老合规师考试网公众号</span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>

export default {
  components: {

  },
  data() {
    return {

    }
  },



  mounted() {

  },
  created() {

  },
  methods: {


  },
};
</script>

<style lang="scss" scoped>
.footer-wrap {
  height: 175px;
  background-color: #282828;
  color: #fff;
}
.safe-wrapper {
  width: 1200px;
  margin: auto;
}
.footer-wrap-layer {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.footer-mesLeft {
  display: flex;
  flex-direction: column;
}
.footer-mesRight {
  display: flex;
}
.footer-mesLeft span {
  font-size: 14px;
  line-height: 28px;
}
.footer-mesRight-code {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.footer-mesRight-code:first-child {
  margin-right: 24px;
}
.footer-mesRight-code span:first-child {
  display: inline-block;
  width: 100px;
  height: 100px;
}
.footer-mesRight-code-01 span:first-child {
  background-image: url(../assets/image/heguishi-ercode.png);
  background-size: cover;
  background-repeat: no-repeat;
}
.footer-mesRight-code-02 span:first-child {
  background-image: url(../assets/image/heguishi-ercode.png);
  background-size: cover;
  background-repeat: no-repeat;
}
.footer-mesRight-code span:nth-child(2) {
  font-size: 12px;
  margin-top: 6px;
  line-height: 16px;
}
</style>
